var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Header'),(_vm.$route.fullPath.includes('dashboard'))?_c('Sidebar'):_vm._e(),_c('v-main',{staticClass:"content mx-0 mx-md-2"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }